import React from "react";

function NothingSelected() {
	return (
		<div className="nothing__content">
			<p>Select something or create an entry!</p>
		</div>
	);
}

export default NothingSelected;
